import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { NewPlayerPayload } from '../../../generated-api';

interface NewPlayerCardProps {
  payload: NewPlayerPayload;
  createdAt: string;
}

export const NewPlayerCard: React.FC<NewPlayerCardProps> = ({ payload, createdAt }) => {
  const formatRelativeTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  return (
    <Link
      data-track="feed_new_player_card"
      to={`/players/${payload.playerId}`}
      className="block bg-surface rounded-lg shadow-sm border border-edge hover:shadow-md transition-shadow duration-200"
    >
      <div className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0 bg-green-100 rounded-full p-2">
              <UserPlusIcon className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-heading">New Player Joined</p>
              <p className="text-xs text-muted">{formatRelativeTime(createdAt)}</p>
            </div>
          </div>
          {payload.playerAvatar ? (
            <img
              src={payload.playerAvatar}
              alt={payload.playerName}
              className="h-12 w-12 rounded-full object-cover"
            />
          ) : (
            <div className="h-12 w-12 rounded-full bg-surface-skeleton flex items-center justify-center text-lg font-medium text-body">
              {payload.playerName.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        <div className="mt-3">
          <p className="text-sm text-body">
            <span className="font-medium text-green-600">{payload.playerName}</span>
            {' has joined the community. Welcome!'}
          </p>
        </div>
      </div>
    </Link>
  );
};
